import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button } from '@mantine/core';

import { useGetForm, usePatchForm } from 'api/forms';
import { ConfirmationDialogModal } from 'components/shared';
import { useShowNotification } from 'hooks';

import { useFormEditContext } from '../context';
import { FormSharingModal } from '../../common';

export const UpperSection = () => {
  const [openShareDetails, setOpenShareDetails] = useState<boolean>(false);
  const { form } = useFormEditContext();
  const { name, signType, id, active } = form;

  const [confirmToggleActiveModalOpen, setConfirmToggleActiveModalOpen] =
    useState(false);
  const { mutateAsync: patchForm } = usePatchForm({ id });
  const { refetch: refetchForm } = useGetForm({ id });

  const { t } = useTranslation('forms');
  const showNotification = useShowNotification();

  const promptToggleConfirmation = () => {
    setConfirmToggleActiveModalOpen(true);
  };

  const toggleActiveState = async () => {
    try {
      const newStateActive = !active;
      const { active: newActive } = await patchForm({
        name,
        signType,
        active: newStateActive,
      });
      await refetchForm();
      showNotification({
        message: t(
          `editView.sidebar.publishing.notification.${
            newActive ? 'activation' : 'deactivation'
          }.success`,
        ),
        color: 'green',
      });

      if (newStateActive) {
        setOpenShareDetails(true);
      }
    } catch (error) {
      console.error(error);
      showNotification({
        message: t(
          `editView.sidebar.publishing.notification.${
            active ? 'deactivation' : 'activation'
          }.error`,
        ),
        color: 'red',
      });
    }
  };

  const getCurrentStateTranslation = (key: string) =>
    t(`editView.sidebar.publishing.${key}.${active ? 'active' : 'inactive'}`);

  return (
    <>
      <Alert
        color={active ? 'green' : 'blue'}
        title={getCurrentStateTranslation('alert.title')}
        sx={theme => ({ marginBottom: theme.other.spacing(2) })}
      >
        {getCurrentStateTranslation('alert.text')}
      </Alert>
      <Button
        variant={active ? 'light' : 'filled'}
        color={active ? 'primary' : 'blue'}
        onClick={promptToggleConfirmation}
      >
        {getCurrentStateTranslation('button')}
      </Button>
      <ConfirmationDialogModal
        title={getCurrentStateTranslation('confirmation.title')}
        message={getCurrentStateTranslation('confirmation.message')}
        confirmButtonText={getCurrentStateTranslation('confirmation.button')}
        opened={confirmToggleActiveModalOpen}
        onClose={() => setConfirmToggleActiveModalOpen(false)}
        onConfirm={toggleActiveState}
      />
      <FormSharingModal
        form={form}
        isOpen={openShareDetails}
        onClose={() => setOpenShareDetails(false)}
      />
    </>
  );
};
